import React, { Component } from 'react';
import { Row, Col, Table  } from "react-bootstrap";
import { toast } from 'react-toastify';
import Select from 'react-select';

import CustomModal from "../../components/Modal/CustomModal";

import { CustomCard } from "../../components/Card/CustomCard";

import { ConsultaBecasSolici, NapBeca, ApBeca, ConsultaUcInscritos } from "../../funciones/BecasFunction";

import BecaDetalle from "./BecaDetalle";
import BecasTable from "./BecasTable";

let datEst = "";
class BecaEstudiantil extends Component {
    state = {
        cantSolicitudes: <i className="fa fa-spinner fa-spin"></i>,
        preloader: {
            icono: "fa fa-spinner fa-spin",
            texto: "Buscando Estudiantes"
        },
        becasSolicit: [],
        msjPre: "Selecciona un estudiante para ver los detalles",
        datEst: "",
        cantuc: { value: 1, label: '1 Unidad de Crédito' },
        ucDisp:[],
        openW: false,
        boton2: {
            icon: "fa fa-check",
            text: "Si",
            disabled: false
        },
        boton1: {
            icon: "fa fa-check",
            text: "Si",
            disabled: false
        },
        openW2: false,
    }

    componentDidMount = () => {
        datEst = "";
        ConsultaBecasSolici ((resp) => {
            let pre = "";
            if (resp.length === 0) pre = {
                icono: "",
                texto: "No existen postulaciones de estudiantes para beca estudiantil"
            }
            this.setState({
                becasSolicit: resp,
                preloader: pre,
                cantSolicitudes: resp.length,
                openW2: false,
            })
        })

        this.cantUcDisp ()
    }

    cantUcDisp = () => {
        let contenido = [{ value: 1, label: '1 Unidad de Crédito' }];
        for (let i = 2; i <= 21; i++){
            contenido.push(
                {value: i, label: `${i} Unidades de Crédito`}
            )
        }

        this.setState({ ucDisp: contenido });
    }
    cambiaUc = (cantuc) => {
        this.setState({ cantuc });
    }

    detalles = (id) => {
        datEst = id;
        ConsultaUcInscritos (id.id_est, (resp) => {
            let contenido = [{ value: 1, label: '1 Unidad de Crédito' }];
            for (let i = 2; i <= resp; i++){
                contenido.push(
                    {value: i, label: `${i} Unidades de Crédito`}
                )
            }

            this.setState({
                ucInscritas:resp,
                datEst: id,
                ucDisp: contenido
            })
        })
    }

    contenido = () => {
        let { cantSolicitudes, preloader, becasSolicit, cantuc, ucDisp } = this.state;

        const styles = {
            padding: 5, fontSize: 12
        }

        let becasSolicitadas = () => {
            if (becasSolicit.length === 0) return (
                <tr>
                    <td colSpan={4} align="center" className="text-danger"><i className={preloader.icono}></i> {preloader.texto}</td>
                </tr>
            )
            
            return (
                becasSolicit.map(option => (
                    <BecasTable key={option.id} datos={option}
                    funcionDetalle = {(id) => {
                        datEst = ""
                        this.detalles(id)}
                    }/>
                ))
            )
        }

        let detallesBeca = () => {
            if (datEst === "") return (
                <div className="text-primary" align="center">{this.state.msjPre}</div>
            )

            return (<BecaDetalle datos={datEst}/>)
        }

        let nombre = (nom) => {
            let nomb = ""
            if (nom !== null) nomb = nom
            return nomb
        }

        let tipoBeca = (tipo) => {
            switch (tipo) {
                case "1": return "BECA COMPLETA"
                case "2": return "MEDIA BECA"
                case "3": return "BECA TRABAJO"
                default : return "BECA COMPLETA"
            }
        }

        let aprobación = () => {
            if (datEst === "") return null

            return (
                <React.Fragment>
                    <div className="custom-alert-danger custom-mt-10">
                        <i className="fa fa-handshake-o"></i> Otorgar Beca a <strong>{`${datEst.nombre_1} ${nombre(datEst.nombre_2)} ${datEst.apellido_1} ${nombre(datEst.apellido_2)}`}</strong>
                    </div>
                    <div className="custom-sem-historico custom-mt-10" style={{backgroundColor:  "#FFF"}}>
                        <Row>
                            <Col md={6} style={{paddingTop: 5}}>
                                <strong style={{fontSize: 10}}>Solo para seleccionar en caso de aprobar la solicitud de Beca</strong>
                                <div className="text-muted">Cantidad de Unidades de Crédito para la beca</div>
                            </Col>
                            <Col md={6}>
                                <Select
                                    isSearchable ={true}
                                    value={cantuc}
                                    onChange={this.cambiaUc}
                                    options={ucDisp}
                                />
                            </Col>
                        </Row>
                    </div>
                    <div className="custom-mt-10 text-danger" align="right">
                        <strong>Beca Solicitada: </strong> {tipoBeca(datEst.tipo)}
                    </div>
                    
                    <div className="custom-alert-info custom-mt-30"><i className="fa fa-gear"></i> Acciones para la Solicitud</div>
                    
                    <div className="custom-mt-10" align="right">
                        <div className="btn-group">
                            <button className="btn btn-primary" onClick={() => {this.setState({openW2: true})}} style={{borderWidth: 1}}><i className="fa fa-check"></i> Aprobar</button>
                            <button className="btn btn-danger" onClick={() => {this.setState({openW: true})}} style={{borderWidth: 1}}><i className="fa fa-times"></i> No Aprobar</button>
                        </div>
                    </div>
                </React.Fragment>
            )
        }
        
        return (
            <React.Fragment>
                <div className="custom-alert-warning" style={{padding: 5}}>
                    <div><i className="fa fa-clone"></i> Solicitudes de Becas <strong>({cantSolicitudes})</strong></div>
                </div>
                <div className="custom-alert-warning custom-mt-10" style={{padding: 5}}>
                    <div className="table-responsive" style={{backgroundColor:"#FFF", overflowX:"hidden", overflowY: "auto", maxHeight: 200}}>
                        <Table striped hover bordered>
                            <tbody>
                                <tr className="custon-back-color-warning">
                                    <td width="50%" style={styles}><strong>Estudiante</strong></td>
                                    <td align="center" width="35%" style={styles}><strong>Carrera</strong></td>
                                    <td align="center" width="15%" style={styles}><strong>Tipo</strong></td>
                                    <td align="center" width="100px" style={styles}><strong>Acciones</strong></td>
                                </tr>
                                {becasSolicitadas()}
                            </tbody>
                        </Table>
                    </div>
                </div>
                <div className="custom-mt-10">
                    {detallesBeca()}
                </div>
                <div className="custom-mt-10">
                    {aprobación()}
                </div>
            </React.Fragment>
        )
    }

    Aprobar = () => () => {
        if (this.state.boton1.disabled === true) return null;

        this.setState({
            boton1: {
                icon: "fa fa-spin fa-spinner",
                text: "Espera",
                disabled: true
            },
        }, () => {
            ApBeca (datEst.id_est, this.state.cantuc.value, this.state.cantuc.label, (resp) => {
                datEst = "";
                ConsultaBecasSolici ((resp) => {
                    let pre = "";
                    if (resp.length === 0) pre = {
                        icono: "",
                        texto: "No existen postulaciones de estudiantes para beca estudiantil"
                    }
                    this.setState({
                        becasSolicit: resp,
                        preloader: pre,
                        cantSolicitudes: resp.length,
                        openW: false,
                        openW2: false,
                        boton2: {
                            icon: "fa fa-check",
                            text: "Si",
                            disabled: false
                        },
                        boton1: {
                            icon: "fa fa-check",
                            text: "Si",
                            disabled: false
                        },
                        cantuc: { value: 1, label: '1 Unidad de Crédito' },
                    })
                    toast.info("Haz Aprobado correctamente la petición de beca del estudiante. Se le ha enviado una notificación",{autoClose: 4000});
                })
            })
        });
    }

    noAprobar = () => () => {
        if (this.state.boton2.disabled === true) return null;

        this.setState({
            boton2: {
                icon: "fa fa-spin fa-spinner",
                text: "Espera",
                disabled: true
            },
        }, () => {
            NapBeca (datEst.id_est, (resp) => {
                datEst = "";
                ConsultaBecasSolici ((resp) => {
                    let pre = "";
                    if (resp.length === 0) pre = {
                        icono: "",
                        texto: "No existen postulaciones de estudiantes para beca estudiantil"
                    }
                    this.setState({
                        becasSolicit: resp,
                        preloader: pre,
                        cantSolicitudes: resp.length,
                        openW: false,
                        openW2: false,
                        boton2: {
                            icon: "fa fa-check",
                            text: "Si",
                            disabled: false
                        },
                        boton1: {
                            icon: "fa fa-check",
                            text: "Si",
                            disabled: false
                        },
                        cantuc: { value: 1, label: '1 Unidad de Crédito' },
                    })
                    toast.info("Haz cancelado correctamente la petición de beca del estudiante. Se le ha enviado una notificación",{autoClose: 4000});
                })
            })
        })
    }

    showModalOk = () => {
        if (datEst === "") return null;

        let { boton1, openW2, cantuc } = this.state;
        let contenidoModal = () => (
            <React.Fragment>
                <div>¿Deseas <strong className="text-primary">APROBAR</strong> la solicitud de beca de este estudiante con un total de <strong className="text-danger">{(cantuc.label).toUpperCase()}</strong>?</div>
                <div style={{fontSize:10}}>Se le enviará un email de notificación al estudiante</div>
            </React.Fragment>
        )
        return (
            <CustomModal
                isopen =  {openW2}
                titulo = {<div className="text-primary">Confirmación</div>}
                contenido = {contenidoModal()}
                boton1 = {<React.Fragment><i className= {boton1.icon}></i> {boton1.text}</React.Fragment>}
                boton2 = {<React.Fragment><i className= "fa fa-times"></i> No</React.Fragment>}
                funcion1 = {this.Aprobar()}
                funcion2 = {() => {this.setState({openW2: false})}}/>
        );
    }

    showModalNOk = () => {
        if (datEst === "") return null;
        
        let { boton2, openW } = this.state;
        let contenidoModal = () => (
            <React.Fragment>
                <div>¿Deseas <strong className="text-danger">CANCELAR</strong> la solicitud de beca de este estudiante?</div>
                <div style={{fontSize:10}}>Esta opción no puede deshacerse y se le enviará un email de notificación al estudiante</div>
            </React.Fragment>
        )
        return (
            <CustomModal
                isopen =  {openW}
                titulo = {<div className="text-primary">Confirmación</div>}
                contenido = {contenidoModal()}
                boton1 = {<React.Fragment><i className= {boton2.icon}></i> {boton2.text}</React.Fragment>}
                boton2 = {<React.Fragment><i className= "fa fa-times"></i> No</React.Fragment>}
                funcion1 = {this.noAprobar()}
                funcion2 = {() => {this.setState({openW: false})}}/>
        );
    }

    ayuda = () => (
        <React.Fragment>
            <div align="justify">
                En esta sección puedes <span className="text-primary">Aceptar</span> o <span className="text-danger">Rechazar</span> las solicitudes de Becas
            </div>
            <div className="custom-mt-10" align="justify">
                Si tienes solicitudes pendientes, podrás ver el listado y en la parte derecha de cada estudiante el botón <button className="btn btn-primary btn-xs" style={{borderWidth: 1}}><i className="fa fa-share-square-o"></i> Ver  Detalles</button> que al hacer click te permitirá revisar la solicitud
            </div>
            <div className="custom-mt-10" align="justify">
                Al hacer click se desplegará la información de la solicitud:
            </div>
            <div className="custom-mt-10 text-primary">Datos del Estudiante</div>
            <div className="custom-mt-10" align="justify">
                Muestra la información básica del estudiante incluyendo números de teléfonos (Si están disponibles)
            </div>
            <div className="custom-mt-10 text-primary">Datos Académicos</div>
            <div className="custom-mt-10" align="justify">
                En esta sección se encuentra un listado de las materias inscritas por el estudiante y su rendimiento detallado por cortes de nota
            </div>
            <div className="custom-mt-10 text-primary">Datos Históricos</div>
            <div className="custom-mt-10" align="justify">
                Para ver el archivo histórico primero selecciona la carrera de las que estén disponibles y se desplegará la lista con el archivo histórico del estudiante
            </div>
            <div className="custom-mt-10 text-danger"><i className="fa fa-handshake-o"></i> Otorgar Beca</div>
            <div className="custom-mt-10" align="justify">
                Debes seleccionar la cantidad de Unidades de crédito a otorgar (Solo en el caso de aprobar la solicitud)
            </div>

            <Row>
                <Col md={5} className="custom-mt-10" align="right">
                    <button className="btn btn-primary btn-sm" style={{borderWidth:1}}><i className="fa fa-check"></i> Aprobar</button>
                </Col>
                <Col md={7} align="justify" className="custom-mt-10">
                    Este botón aprueba la solicitud de beca.
                    <div style={{fontSize: 11}}><strong className="text-danger">Importante: Este botón presiónalo solo cuando hayas revisado correctamente dicha solicitud, ya que se descontará al estado de cuenta del estudiante</strong></div>
                </Col>
                <Col md={5} className="custom-mt-10" align="right">
                    <button className="btn btn-danger btn-sm" style={{borderWidth:1}}><i className="fa fa-times"></i> No Aprobar</button>
                </Col>
                <Col md={7} align="justify" className="custom-mt-10">
                    Este botón anula la solicitud del estudiante (Este podrá realizarla nuevamente si así lo desea).
                </Col>
                <Col md={12} align="justify" className="custom-mt-10">
                    En ambos casos (Aprobar y No Aprobar) se le enviará una notificación al email del estudiante
                </Col>
            </Row>
        </React.Fragment>
    )

    render() {
        return (
            <div className="content">
                <Row>
                    <Col md={8}>
                        {this.contenido()}
                    </Col>
                    <Col md={4}>
                        <div style={{borderRadius: "4px 4px",}}>
                            <CustomCard
                                styles ={{backgroundColor: "#1f2f6e", borderTopLeftRadius: 4, borderTopRightRadius: 4,}}
                                title={<span style={{color: "#fff"}}><i className="pe-7s-help1"></i> Ayuda</span>}
                                category={<span style={{color: "#fff"}}>Becas Estudiantiles</span>}
                                color="#a80012"
                                content={this.ayuda()}
                            />
                        </div>
                    </Col>
                </Row>
                {this.showModalNOk()}
                {this.showModalOk()}
            </div>
        );
    }
}
 
export default BecaEstudiantil;


// WEBPACK FOOTER //
// ./src/views/Bienestar/BecaEstudiantil.jsx